import { LicenseStatus } from '@/api/services/user';

export const showDigaPatientWarning = (licenseStatus: LicenseStatus) => {
  if (licenseStatus.type === 'diga' && licenseStatus.daysLeft <= 30) {
    return true;
  } else {
    return false;
  }
};

export const showSelfPayerWarning = (licenseStatus: LicenseStatus) => {
  if (licenseStatus.type === 'selfpay' && licenseStatus.daysLeft <= 14) {
    return true;
  } else {
    return false;
  }
};
